
// import { useState, useEffect} from "react"; // , useMemo 
import { ThemeProvider } from "@mui/material/styles"; //, createTheme
// import { Box, Container, CssBaseline, Typography } from '@mui/material';
// import logo from './assets/Usidistrib_logo.png';
import { Container, CssBaseline, Typography, Stack, Alert } from "@mui/material";
import theme from "./theme";
import { useClubs } from "./hooks/useClubs";
import ClubsList from "./components/ClubsList";

// App.tsx (extrait)
import Button from "@mui/material/Button";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { exportClubsToJson } from "./lib/export-json";
import { exportClubsToCsv } from "./lib/export-csv";


export default function App() {
  const { clubs, loading, error } = useClubs();

  // Détecter le thème par défaut du navigateur
  // const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  // const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  // const [darkMode, setDarkMode] = useState(mediaQuery.matches); //useState(prefersDark);

  // Écoute les changements du thème système
  // useEffect(() => {
  //   const handler = (e: MediaQueryListEvent) => setDarkMode(e.matches);
  //   mediaQuery.addEventListener("change", handler);
  //   return () => mediaQuery.removeEventListener("change", handler);
  // }, [mediaQuery]);

  // // Créer le thème avec transition fluide
  // const theme2 = useMemo(
  //   () =>
  //     createTheme({
  //       palette: {
  //         mode: darkMode ? "dark" : "light",
  //         background: {
  //           default: darkMode ? "var(--color-dark-bg)" : "var(--color-light-bg)",
  //           paper: darkMode ? "var(--color-dark-bg)" : "var(--color-light-bg)"
  //         },
  //         text: {
  //           primary: !darkMode ? "var(--color-dark-text)" : "var(--color-light-text)"
  //         }
  //       },
  //       components: {
  //         MuiCssBaseline: {
  //           styleOverrides: {
  //             body: {
  //               transition: "background-color 0.3s ease, color 0.3s ease",
  //             },
  //           },
  //         },
  //       },
  //     }),
  //   [darkMode]
  // );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Stack spacing={3}>

          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" component="h1">Répertoire des clubs de judo</Typography>

            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadRoundedIcon />}
              onClick={() => exportClubsToJson(clubs, "clubs-export.json")}
            >
              Export en JSON
            </Button>

            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadRoundedIcon />}
              onClick={() => exportClubsToCsv(clubs, "clubs-export.csv")}
            >
              Export en CSV
            </Button>
          </Stack>


          {error && <Alert severity="error">Erreur de chargement : {error}</Alert>}
          {loading ? (
            <Typography>Chargement des clubs…</Typography>
          ) : (
            <ClubsList clubs={clubs} />
          )}
        </Stack>
      </Container>
    </ThemeProvider>
  );
}


//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container sx={{ textAlign: "center", mt: 4 }}>
//         <Typography variant="h4" gutterBottom>
//           Voici une liste (non exhaustive) des clubs de judo en Europe.
//         </Typography>

//         <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
//           <img id="logo" src={logo} alt="Usidistrib Logo" width={800} />
//         </Box>

//       </Container>
//       {/* Footer en bas à droite */}
//       <Box
//         sx={{
//           position: "fixed",
//           bottom: 20,
//           right: 20,
//           fontSize: "2rem",
//           cursor: "pointer",
//         }}
//         onClick={() => setDarkMode(!darkMode)}
//       >
//         {darkMode ? "🌙" : "🌞"}
//       </Box>

//     </ThemeProvider>
//   );
// }


